module.exports = __webpack_public_path__ + "static/media/1144409475.f68c8696.jpg";